import React, { useCallback } from 'react';
import SelectWithAnalytics from '@atlassian/jira-issue-select-with-analytics/src/index.tsx';
import { mapDataToSelectOptions } from '@atlassian/jira-issue-field-select/src/ui/edit/utils.tsx';
import type { SelectOption } from '@atlassian/jira-issue-field-select/src/ui/edit/types.tsx';
import type { Option } from '@atlassian/jira-issue-field-select-base/src/common/types.tsx';
import type { ActionMeta } from '@atlassian/jira-common-components-picker/src/model.tsx';
import { closeMenuOnScroll } from '../../common/utils/select/index.tsx';
import { validateSelectField } from '../../common/utils/validators/index.tsx';
import { withFormField } from '../../common/ui/with-form-field/index.tsx';
import { FieldContainer } from '../../common/ui/fields/styled.tsx';
import {
	transformDefaultSelectValues,
	onFilterOption,
} from '../../common/ui/fields/base-fields/select-field/utils.tsx';
import type {
	SelectFieldConfig,
	SelectFieldProps,
	FieldValue,
} from '../../common/ui/fields/base-fields/select-field/types.tsx';

type Props = SelectFieldProps & {
	fieldProps: {
		value: SelectOption;
		onChange: (value: Option | Option[] | null, actionMeta: ActionMeta<Option>) => void;
		id: string;
		isRequired?: boolean;
	};
	error?: string;
};

const SingleSelectFieldWithAnalyticsView = (props: Props): React.JSX.Element => {
	const {
		fieldId,
		autoFocus = false,
		allowedValues,
		width,
		error,
		fieldProps: { value, onChange, id, isRequired },
		isReadOnly = false,
		onCloseMenuOnScroll = closeMenuOnScroll,
		isDropdownMenuFixedAndLayered = false,
	} = props;

	const options = mapDataToSelectOptions(allowedValues);

	const handleChange = useCallback(
		(newValue: Option | Option[] | null) => {
			// SelectWithAnalytics calls: handleChange(value, actionMeta)
			// But we only pass the value to form field system
			// @ts-expect-error - TS2345 - Argument type doesn't match exactly but is compatible
			onChange(newValue);
		},
		[onChange],
	);

	return (
		<FieldContainer width={width}>
			<SelectWithAnalytics
				fieldId={fieldId || id}
				options={options}
				value={value}
				onChange={handleChange}
				autoFocus={autoFocus}
				validationState={error ? 'error' : undefined}
				classNamePrefix={`select-${fieldId}`}
				isMulti={false}
				hideSelectedOptions
				closeMenuOnScroll={onCloseMenuOnScroll}
				isClearable
				filterOption={onFilterOption}
				isDisabled={isReadOnly}
				isRequired={isRequired}
				inputId={id}
				closeMenuOnSelect
				menuPosition={isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined}
			/>
		</FieldContainer>
	);
};

const SingleSelectFieldWithAnalytics = withFormField({
	transformDefaultValue: transformDefaultSelectValues,
	validator: validateSelectField,
	// @ts-expect-error - TS2345 - Argument of type component is not assignable to parameter
})<SelectFieldConfig, FieldValue>(SingleSelectFieldWithAnalyticsView);

export default SingleSelectFieldWithAnalytics;
export { SingleSelectFieldWithAnalytics };
